import { styled } from '@mui/material/styles';

export type TIconSize = 'small' | 'medium' | 'large';

interface IconProps {
	variant: 'midGrey' | 'main' | 'disabled';
	size?: TIconSize;
}

const iconSizeMap: Record<TIconSize, number> = {
	small: 30,
	medium: 42,
	large: 48,
};

export const Root = styled('div')(() => ({
	justifySelf: 'end',
	alignSelf: 'start',
	display: 'grid',
	gridAutoFlow: 'column',
	gridTemplateRows: 'max-content',
	gridAutoColumns: 'max-content',
}));

export const SymbolCircle = styled('div')<{
	ownerState: IconProps;
}>(({ theme, ownerState: { variant, size } }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: iconSizeMap[size || 'small'],
	height: iconSizeMap[size || 'small'],
	borderRadius: '50%',
	border: `1px solid ${theme.palette.neutral[0]}`,
	color: theme.palette.primary.main,

	...(variant === 'main' && {
		background: theme.palette.secondary.main,
	}),

	...(variant === 'midGrey' && {
		background: theme.palette.neutral[40],
	}),

	...(variant === 'disabled' && {
		background: theme.palette.neutral[0],
		color: theme.palette.neutral[80],
	}),

	'&:not(:first-of-type)': {
		marginLeft: '-4px',
	},

	'& svg': {
		display: 'block',
		flex: '0 0 auto',

		...(size === 'small' && {
			width: 30,
		}),

		...(size === 'medium' && {
			width: 32,
		}),
	},
}));
